export const RESET_USER_ON_LOGIN = false;
export const INCLUDE_PHONE_VERIFICATION_STEP = false;

// SAMPLE SOLANA ADDRESS
// Bo3zJ3YsDh2VoZp4MvBsiRHUGJhCsbHXC54tDrsknjET

// Cant update users name
// https://community.auth0.com/t/update-a-user-api-does-not-allow-updating-name/6838/13
